import * as i0 from '@angular/core';
import { Component, Input, HostBinding, NgModule, Directive } from '@angular/core';
import { CommonModule } from '@angular/common';

class DzLabelComponent {
    constructor() {
        /**
         * Label type:
         * feature has size 12px
         * status has size 14px and extra top/bottom padding
         */
        this.type = 'feature';
    }
    get feature() {
        return this.type === 'feature';
    }
    get status() {
        return this.type === 'status';
    }
}
DzLabelComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DzLabelComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DzLabelComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: DzLabelComponent, selector: "dz-label", inputs: { type: "type" }, host: { properties: { "class.feature": "this.feature", "class.status": "this.status" } }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, styles: [":host{border:1px solid transparent;border-radius:2px;display:inline-block;font-family:FortBold,Arial,sans-serif;padding:0 .5rem}:host.feature{font-size:.75rem;line-height:.875rem}:host.status{font-size:.875rem;line-height:1.375rem}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DzLabelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dz-label', template: '<ng-content></ng-content>', styles: [":host{border:1px solid transparent;border-radius:2px;display:inline-block;font-family:FortBold,Arial,sans-serif;padding:0 .5rem}:host.feature{font-size:.75rem;line-height:.875rem}:host.status{font-size:.875rem;line-height:1.375rem}\n"] }]
        }], propDecorators: { type: [{
                type: Input
            }], feature: [{
                type: HostBinding,
                args: ['class.feature']
            }], status: [{
                type: HostBinding,
                args: ['class.status']
            }] } });

class DzLabelModule {
}
DzLabelModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DzLabelModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DzLabelModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DzLabelModule, declarations: [DzLabelComponent], imports: [CommonModule], exports: [DzLabelComponent] });
DzLabelModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DzLabelModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DzLabelModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DzLabelComponent],
                    imports: [CommonModule],
                    exports: [DzLabelComponent]
                }]
        }] });

let badgeId = 0;
const BADGE_CONTENT_CLASS = 'dz-badge-content';
class DzBadgeDirective {
    constructor(elementRef, renderer) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.dzBadgeColor = 'black';
        this.dzBadgeOverlap = true;
        this.dzBadgePosition = 'right-start';
        this.dzBadgeSize = 'medium';
        this.id = badgeId++;
    }
    ngOnInit() {
        this.addDynamicClasses();
        if (!this.badgeElement) {
            this.badgeElement = this.createBadge();
            this.updateRenderedContent(this.dzBadge);
        }
    }
    ngOnChanges(changes) {
        if (changes.dzBadgePosition || changes.dzBadgeColor) {
            this.addDynamicClasses();
        }
        if (!changes?.dzBadge?.firstChange) {
            this.updateRenderedContent(this.dzBadge);
        }
    }
    getBadgeElement() {
        return this.badgeElement;
    }
    addDynamicClasses() {
        this.removeClassesByPrefix(this.elementRef.nativeElement, 'dz-badge-position');
        this.removeClassesByPrefix(this.elementRef.nativeElement, 'dz-badge-color');
        this.elementRef.nativeElement.classList.add(`dz-badge-position-${this.dzBadgePosition}`, `dz-badge-color-${this.dzBadgeColor}`);
    }
    removeClassesByPrefix(el, prefix) {
        for (let i = el.classList.length - 1; i >= 0; i--) {
            if (el.classList[i].startsWith(prefix)) {
                el.classList.remove(el.classList[i]);
            }
        }
    }
    createBadge() {
        const badgeElement = this.renderer.createElement('span');
        // The badge is aria-hidden because we don't want it to appear in the page's navigation flow
        badgeElement.setAttribute('aria-hidden', 'true');
        badgeElement.setAttribute('id', `dzBadgeContent${this.id}`);
        badgeElement.classList.add(BADGE_CONTENT_CLASS);
        this.elementRef.nativeElement.appendChild(badgeElement);
        return badgeElement;
    }
    updateRenderedContent(content) {
        const newContentNormalized = `${content ?? ''}`.trim();
        if (!this.badgeElement) {
            this.badgeElement = this.createBadge();
        }
        if (this.badgeElement) {
            this.badgeElement.textContent = newContentNormalized;
        }
        this.dzBadge = newContentNormalized;
    }
}
DzBadgeDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DzBadgeDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive });
DzBadgeDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: DzBadgeDirective, selector: "[dzBadge]", inputs: { dzBadge: "dzBadge", dzBadgeColor: "dzBadgeColor", dzBadgeDisabled: "dzBadgeDisabled", dzBadgeHidden: "dzBadgeHidden", dzBadgeOverlap: "dzBadgeOverlap", dzBadgePosition: "dzBadgePosition", dzBadgeSize: "dzBadgeSize" }, host: { properties: { "class.dz-badge-overlap": "dzBadgeOverlap", "class.dz-badge-medium": "dzBadgeSize === \"medium\"", "class.dz-badge-large": "dzBadgeSize === \"large\"", "class.dz-badge-small": "dzBadgeSize === \"small\"", "class.dz-badge-hidden": "dzBadgeHidden", "class.dz-badge-disabled": "dzBadgeDisabled" }, classAttribute: "dz-badge" }, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DzBadgeDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[dzBadge]',
                    // eslint-disable-next-line @angular-eslint/no-host-metadata-property
                    host: {
                        class: 'dz-badge',
                        '[class.dz-badge-overlap]': 'dzBadgeOverlap',
                        '[class.dz-badge-medium]': 'dzBadgeSize === "medium"',
                        '[class.dz-badge-large]': 'dzBadgeSize === "large"',
                        '[class.dz-badge-small]': 'dzBadgeSize === "small"',
                        '[class.dz-badge-hidden]': 'dzBadgeHidden',
                        '[class.dz-badge-disabled]': 'dzBadgeDisabled'
                    }
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { dzBadge: [{
                type: Input
            }], dzBadgeColor: [{
                type: Input
            }], dzBadgeDisabled: [{
                type: Input
            }], dzBadgeHidden: [{
                type: Input
            }], dzBadgeOverlap: [{
                type: Input
            }], dzBadgePosition: [{
                type: Input
            }], dzBadgeSize: [{
                type: Input
            }] } });

class DzBadgeModule {
}
DzBadgeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DzBadgeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DzBadgeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DzBadgeModule, declarations: [DzBadgeDirective], imports: [CommonModule], exports: [DzBadgeDirective] });
DzBadgeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DzBadgeModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DzBadgeModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DzBadgeDirective],
                    imports: [CommonModule],
                    exports: [DzBadgeDirective]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { DzBadgeDirective, DzBadgeModule, DzLabelComponent, DzLabelModule };
